export default "__VITE_ASSET__D0O_es7k__"